<template>

  <tr
  :class="{'selected': selected[item.tempID]}">
    <td class="sticky">
      <div class="c-flex align-center">
        <v-btn
        v-if="editable"
        icon
        text
        class="ma-0"
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ totalInStock }} || {{quantityTimesN }}
                {{ item }}
                {{ buildMaterialsTimesN }}
              </span>
            </div>
          </v-card>
        </v-menu>
        
        <text-highlight class="text-ellipsed" :queries="nameKeywords" highlightClass="white--text color1" highlightStyle="">{{ item.definition.name }}</text-highlight>

        <span class="caption ml-2 grey--text overline">
          ({{ invItemCount }})
        </span>

      </div>
    </td>
    <td>
      <c-ms-ii
      v-if="!editable"
      :metric_definition="item.definition" 
      :realValue="quantityTimesN"
      :key="'d' + item.definition.id"
      alwaysScale
      labelMode
      ></c-ms-ii>
    </td>
    <td>
      <template v-if="totalInStock === 0">
        <v-chip
        color="pink"
        x-small
        text-color="white">
          OUT OF STOCK
        </v-chip>
      </template>
      <template v-else>

        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="totalDebited"
        :key="'e' + item.definition.id"
        alwaysScale
        labelMode
        ></c-ms-ii>

        <!--
        <span class="caption textSecondary--text">
          &nbsp;/&nbsp;
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue="totalInStock"
          :key="'f' + item.definition.id"
          alwaysScale
          labelMode
          ></c-ms-ii>
        </span>
        -->
        <v-progress-linear
        class="ma-0"
        :value="percentDict[item.definition.id ]"
        :key="(item.definition || {}).id"
        style="max-width: 200px;"
        :color="progressColor"
        background-color="backgroundCard"
        height="5"
        rounded
        striped
        ></v-progress-linear>
      </template>

    
      <!-- ERRORS -->
      <div v-if="!editable && quantityTimesN !== totalDebited">
        <div v-if="totalDebited > quantityTimesN" small class="pink--text">
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue="totalDebited - quantityTimesN"
          :key="'e' + item.definition.id"
          alwaysScale
          labelMode
          ></c-ms-ii>
          <div>
            over the recipe
          </div>
        </div>
        <div v-else small class="pink--text">
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue="quantityTimesN - totalDebited"
          :key="'e' + item.definition.id"
          alwaysScale
          labelMode
          ></c-ms-ii>
          <div>
            short on recipe
          </div>
        </div>
      </div>
      <div v-if="remainMapError" class="pink--text">
        Batch error
        <div class="overline textSecondary--text">
          Click for info
        </div>
      </div>

    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: {
    item: {
      definition: {}
    },
    editable: false,
    quantity: null,
    buildMaterialsTimesN: {},
    totalInStock: 0,
    difference: null,
    debitMap: null,
    debitMapTallied: null,
    remainMap: null,
    selected: null,
    searchFilters: null,
    maxQuantity: null,
    percentDict: null,
    inventoryView: null
  },
  components: {
    TextHighlight
  },
  data () {
    return {
      expand: false
    }
  },
  computed: {
    invItemCount () {
      return Object.keys(this.inventoryView[this.item.definition.id] || {}).length
    },
    remainMapError () {
      return Object.values(this.remainMap[this.item.definition.id] || {}).find(remaining => remaining < 0)
    },
    quantityTimesN () {
      return this.buildMaterialsTimesN[(this.item.definition || {}).id]
    },
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    },
    totalDebited () {
      return this.debitMapTallied[this.item.definition.id]
    },
    progressColor () {
      if (this.remainMapError) {
          return 'pink'
        }
      if (this.editable) {
        return 'color1'
      } else {
        return this.difference < 0 ? 'pink' : 'color1'
      }
    }
  }
}
</script>
